import { render, staticRenderFns } from "./StateFeeSeafarer.vue?vue&type=template&id=99741c36"
import script from "./StateFeeSeafarer.vue?vue&type=script&lang=ts"
export * from "./StateFeeSeafarer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports